import { render, staticRenderFns } from "./active-user-card.vue?vue&type=template&id=f51f9ab0"
import script from "./active-user-card.vue?vue&type=script&lang=js"
export * from "./active-user-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports